// Images with process.env.PUBLIC_URL to ensure correct paths
export const HERO_IMAGE = `${process.env.PUBLIC_URL}/design_ops_delivered.png`;
export const FLOW_IMAGE = `${process.env.PUBLIC_URL}/flow_image.png`;
export const EXAMPLE_IMAGE = `${process.env.PUBLIC_URL}/design_pr_example.png`;
export const LOGO_PLACEHOLDER = `${process.env.PUBLIC_URL}/logo192.png`; 